module.exports = __webpack_public_path__ + "static/media/TileUNP.f1a599fa.png";